// extracted by mini-css-extract-plugin
export default {"box":"box--nD8al","user":"user--pnT2B"};